import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import SetupDownload from '../../components/SetupDownload/SetupDownload';
import Footer from '../../components/Footer/Footer';
import '../MarketingDetailPage.scss';

const SetupDownloadPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="marketing-detail-page marketing-detail-page--setup">
      <Helmet>
        <title>설치파일 다운로드 - 매쓰테일러 PDF HWP 변환 · 수학 AI 플랫폼</title>
        <meta name="description" content="매쓰테일러 설치파일을 다운로드하세요. Windows 환경에서 PDF HWP 변환, 수학 문제풀이 AI, 도형 자동 작도 기능을 바로 시작할 수 있습니다." />
        <meta name="keywords" content="매쓰테일러 설치파일, 매쓰테일러 다운로드, 수학 AI 프로그램 설치, PDF HWP 변환 설치" />
        <meta property="og:title" content="설치파일 다운로드 - 매쓰테일러" />
        <meta property="og:description" content="매쓰테일러 Windows 설치파일 다운로드 페이지입니다." />
        <meta property="og:url" content="https://xn--vl2b19ao0ssqc39r.kr/setup-download" />
      </Helmet>
      <SetupDownload />
      <Footer />
    </main>
  );
};

export default SetupDownloadPage;